import React from 'react';
import { meetingToken } from 'api/zoom';
import { getMeetingUuid } from 'utils/sessionStorage';

const useProviderMeetingToken = (
    sessionKey?: string,
): [string | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<string>();
    const fetchData = async () => {
        const uuid = getMeetingUuid();
        if (loading || !sessionKey || !uuid) return;
        try {
            setLoading(true);
            const result = await meetingToken(`${sessionKey}`, uuid);
            if (!result.error) {
                const resData = result?.data?.data?.zoomSessionToken || undefined;
                setData(resData);
            }
            // setLoading(false);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        if (sessionKey) {
            setData(undefined);
            fetchData();
        }
    }, [sessionKey]);

    return [data, loading, fetchData];
};

export default useProviderMeetingToken;
